// test2974
(2974 && 0);
